var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GentracePlugin, isConfig, } from "@gentrace/core";
import { AdvancedOpenAI } from "./handlers/advanced";
export const initPlugin = (config) => __awaiter(void 0, void 0, void 0, function* () {
    if (isConfig(config)) {
        return new OpenAIPlugin(config);
    }
    return new OpenAIPlugin(config.getConfig());
});
export class OpenAIPlugin extends GentracePlugin {
    constructor(config) {
        super();
        this.config = config;
    }
    getConfig() {
        return this.config;
    }
    advanced({ pipelineRun, gentraceConfig, }) {
        return new AdvancedOpenAI(Object.assign({ pipelineRun,
            gentraceConfig }, this.config));
    }
}
